export type HoverCardData = {
  memberId: string;
  name: string;
  email: string;
  title: string | null;
  profilePictureUrl: string | null;
  managerName: string | null;
  directReportCount: number;
};

type CacheEntry = {
  data: HoverCardData;
  expiresAt: number;
};

const TTL_MS = 5 * 60 * 1000; // 5 minutes

const cache = new Map<string, CacheEntry>();

export function getCachedHoverCard(memberId: string): HoverCardData | null {
  const entry = cache.get(memberId);
  if (!entry) return null;
  if (Date.now() > entry.expiresAt) {
    cache.delete(memberId);
    return null;
  }
  return entry.data;
}

export function setCachedHoverCard(data: HoverCardData): void {
  cache.set(data.memberId, { data, expiresAt: Date.now() + TTL_MS });
}
